// extracted by mini-css-extract-plugin
export default {"contact_page":"style_contact_page__0DcIH","section_title":"style_section_title__pe7MJ","section_description":"style_section_description__l1O1i","box":"style_box__CEVbs"};